import { useState, type FormEvent } from "react";
import { site } from "../../siteConfig";
import type { FormField, FormSection } from "../../content/industry";
import { SectionHeading } from "./SectionHeading";

function Field({ field, formId }: { field: FormField; formId: string }) {
  const id = `${formId}-${field.name}`;
  const common = { id, name: field.name, required: field.required, autoComplete: field.autocomplete };
  return (
    <div className={field.half ? "ix-field ix-field--half" : "ix-field"}>
      <label htmlFor={id}>{field.label}{field.required ? <span aria-hidden="true"> *</span> : null}</label>
      {field.type === "textarea" ? <textarea {...common} rows={4} />
        : field.type === "select" ? <select {...common} defaultValue=""><option value="" disabled>Selecciona una opción</option>{field.options?.map(option => <option key={option}>{option}</option>)}</select>
        : <input {...common} type={field.type} />}
    </div>
  );
}

/**
 * Formulario de cotización, cita o reservación. No necesita servidor: al enviarlo abre el correo del visitante con los
 * datos ya escritos para {site.email}. Para recibir envíos directamente, cambia handleSubmit por la llamada a tu servicio.
 */
export function ContactForm({ section }: { section: FormSection }) {
  const [status, setStatus] = useState("");
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!form.reportValidity()) return;
    const data = new FormData(form);
    const body = section.fields.map(field => `${field.label}: ${String(data.get(field.name) ?? "")}`).join("\n");
    const subject = `${section.title} · ${site.name}`;
    window.location.href = `mailto:${site.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setStatus(`Abrimos tu aplicación de correo con la solicitud para ${site.email}. Si no se abrió, escríbenos directamente.`);
  };
  return (
    <section id={section.id} className={`ix-section ix-form-section ix-form--${section.variant}`} aria-labelledby={`${section.id}-title`}>
      <div className="ix-container ix-split">
        <div className="ix-form-intro">
          <SectionHeading id={section.id} eyebrow={section.eyebrow} title={section.title} text={section.text} />
          {section.aside?.length ? <ul className="ix-checklist">{section.aside.map(item => <li key={item}>{item}</li>)}</ul> : null}
          <p className="ix-contact-line"><a href={`mailto:${site.email}`}>{site.email}</a> · <a href={`tel:${site.phone.replace(/[^+\d]/g, "")}`}>{site.phone}</a></p>
        </div>
        <form className="ix-form" onSubmit={handleSubmit} noValidate aria-describedby={`${section.id}-note`}>
          <div className="ix-fields">{section.fields.map(field => <Field key={field.name} field={field} formId={section.id} />)}</div>
          <button className="ix-button ix-button--primary" type="submit">{section.submitLabel}</button>
          <p id={`${section.id}-note`} className="ix-note">{section.note}</p>
          <p className="ix-status" role="status" aria-live="polite">{status}</p>
        </form>
      </div>
    </section>
  );
}
